import toastr from 'toastr';
export const RepositoryAuditLog = {
  namespaced: true,

  state: {
    auditLog: {},
    loading: false,
    downloading: false,
    total: 0,
  },

  getters: {
    getTotal: (state) => () => {
      return state.total;
    },

    getAuditLog: (state) => () => {
      return Object.values(state.auditLog) ?? [];
    },

    isAuditLogLoaded: (state) => () => {
      return Object.values(state.auditLog).length;
    },

    isAuditLogLoading: (state) => state.loading,

    isGeneratingUrl: (state) => state.downloading,
  },

  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },

    setGeneratingUrl(state, downloading) {
      state.downloading = downloading;
    },

    updateAuditLog(state, auditLog) {
      state.auditLog = auditLog;
    },

    updatePagination(state, total) {
      state.total = total;
    },
  },

  actions: {
    async loadAuditLog(context, request) {
      if (!request.repository) {
        return;
      }
      context.commit('setLoading', true);
      try {
        const response = await this._vm.$api('repositories.audit.index', {
          ...request,
          version: '1.0',
        });

        context.commit('updateAuditLog', response.data.data);
        context.commit('updatePagination', response.data.meta.total);
      } catch (err) {
        console.error(err);
      }
      context.commit('setLoading', false);
    },

    async exportAudit(context, { repositoryUuid, filters }) {
      if (!repositoryUuid) {
        return;
      }
      context.commit('setGeneratingUrl', true);

      let downloadUrl = null;
      let routeParams = {
        version: '1.0',
        repository: repositoryUuid,
      };

      if (filters) {
        routeParams.filter = filters;
      }
      try {
        const response = await this._vm.$api('repositories.audit.export', routeParams);
        downloadUrl = response.data.data?.downloadUrl ?? null;
      } catch (err) {
        console.error(err);
      }

      context.commit('setGeneratingUrl', false);
      if (downloadUrl) {
        window.location = downloadUrl;
      } else {
        toastr.success(
          'Your request is being processed. You will receive an email when the file is ready to be downloaded'
        );
      }
    },

    async triggerAudit(_, { repository, auditLogName, studyId, project, event, subject }) {
      if (!repository || !auditLogName || !project || !event || !subject) {
        console.error('repository, auditLogName, project, event and subject are all required');
        return;
      }

      const routeParams = {
        version: '1.0',
        repository,
        project,
        event,
        subject,
      };

      const query = {
        study_id: studyId,
        audit_log_name: auditLogName,
      };

      try {
        await this._vm.$api('events.audit.store', routeParams, query);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
